import { UserBasic } from '../../../lib/functions/user'
import { I18nLabelVO } from '../../value-object/I18nLabelVO'
import { WbsItemTypeVO } from '../../value-object/WbsItemTypeVO'

export enum WbsItemAdditionalPropertyType {
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  MULTI_LINE_TEXT = 'MULTI_LINE_TEXT',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  CHECKBOX = 'CHECKBOX',
  SELECT = 'SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  ENTITY_SEARCH = 'ENTITY_SEARCH',
}

export type WbsItemAdditionalPropertySelectOption = {
  uuid: string
  selectOption: string
  displayOrder: number
  using?: boolean
}

export enum EntitySearchReferenceEntity {
  // Base wbs item types.
  PROCESS = 'PROCESS',
  DELIVERABLE_LIST = 'DELIVERABLE_LIST',
  DELIVERABLE = 'DELIVERABLE',
  TASK = 'TASK',
  // Ticket wbs item types.
  TICKET = 'TICKET',
  // Others.
  TEAM = 'TEAM',
  PROJECT_MEMBER = 'PROJECT_MEMBER',
}

export type WbsItemAdditionalPropertyEntity = {
  uuid: string
  projectUuid: string
  lockVersion: number
  revision: string
  propertyNameI18n: I18nLabelVO
  propertyType: WbsItemAdditionalPropertyType
  required: boolean
  selectOptions: WbsItemAdditionalPropertySelectOption[] | undefined
  entitySearchReferenceEntity: EntitySearchReferenceEntity | undefined
  entitySearchReferenceEntityTicketType: string | undefined
  wbsItemTypes: WbsItemTypeVO[] | undefined
  using: boolean
  entityExtensionUuid: string | undefined
  entityExtensionExternalId: string | undefined
  createdAt: number
  createdBy: UserBasic | undefined
  updatedAt: number
  updatedBy: UserBasic | undefined
}

export const isAssociatedWithTheWbsItemType = (
  entity: WbsItemAdditionalPropertyEntity,
  wbsItemType?: WbsItemTypeVO
): boolean => {
  if (!wbsItemType) return false
  if (!entity.wbsItemTypes || entity.wbsItemTypes.length === 0) return true
  return entity.wbsItemTypes.some(v => {
    let typeUuid = wbsItemType.baseTicketUuid || wbsItemType.uuid
    return v.uuid === typeUuid
  })
}

export const toChangeLogPath = (
  entity: WbsItemAdditionalPropertyEntity
): string => {
  return `additionalPropertyValues.${entity.uuid}`
}
export const shouldHaveSelectOptions = (
  propertyType: WbsItemAdditionalPropertyType
): boolean => {
  return (
    WbsItemAdditionalPropertyType.SELECT === propertyType ||
    WbsItemAdditionalPropertyType.MULTI_SELECT === propertyType
  )
}
export const shouldHaveEntitySearchReferenceEntity = (
  propertyType: WbsItemAdditionalPropertyType
): boolean => {
  return WbsItemAdditionalPropertyType.ENTITY_SEARCH === propertyType
}
export const shouldHaveEntitySearchReferenceEntityTicketType = (
  propertyType: WbsItemAdditionalPropertyType,
  entitySearchReferenceEntity?: EntitySearchReferenceEntity
): boolean => {
  return (
    WbsItemAdditionalPropertyType.ENTITY_SEARCH === propertyType &&
    EntitySearchReferenceEntity.TICKET === entitySearchReferenceEntity
  )
}
export const propertyTypeIsChangeable = ({
  using,
}: Pick<WbsItemAdditionalPropertyEntity, 'using'>): boolean => {
  return !using
}
export const entitySearchReferenceEntityIsChangeable = ({
  using,
}: Pick<WbsItemAdditionalPropertyEntity, 'using'>): boolean => {
  return !using
}
export const wbsItemTypeIsRemovable = ({
  using,
}: Pick<WbsItemAdditionalPropertyEntity, 'using'>): boolean => {
  return !using
}

// Services.
const getAdditionalPropertyExternalId = (
  additionalProperty: WbsItemAdditionalPropertyEntity
): string => {
  return additionalProperty.entityExtensionExternalId || additionalProperty.uuid
}
export const wbsItemAdditionalPropertyService = {
  getAdditionalPropertyExternalId,
}
